import axios from 'axios';
import { encodeURI } from 'js-base64';

export const handleApiError = (name: string, err: any) => {
  if (!axios.isCancel(err)) {
    console.error(`Error on ${name}. ${err.message}`);
  }
  throw err;
};

export const handleThunkError = (err: any, rejection: Function) => {
  if (!axios.isCancel(err)) {
    return rejection({ message: err.message });
  }
};

export const getFakeToken = (dbId: number, companyUid: string, useCache?: boolean) => {
  const useCacheVal = useCache === undefined ? true : useCache;
  const encodedTokenHeader = encodeURI(JSON.stringify({
    typ: 'JWT',
    alg: 'RS256'
  }));
  const encodedTokenData = encodeURI(JSON.stringify({
    dbid: dbId.toString(),
    uid: companyUid.toString(),
    cache: useCacheVal ? 'true' : 'false'
  }));
  const token = `${encodedTokenHeader}.${encodedTokenData}.`;
  return token;
};